<template>
  <div class="page">
    <LoadingSpinner v-if="processing" id="loading-spinner" />
    <div id="action-bar">
      <div id="page-title">Lab</div>
      <div class="horiz">
        <StatusFilterToggle v-model="statusFilter" />
      </div>
    </div>
    <table>
      <thead>
        <tr>
          <th>Created</th>
          <th>Kit</th>
          <th>Respondent</th>
          <th>BW User</th>
          <th>Status</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="test in allTests"
          :key="test.id"
          @click="
            addPanel('panel-edit-test', {
              testId: test.id,
              userId: test.userId
            })
          "
        >
          <td>{{ test.kit.created | date }}</td>
          <td>{{ test.kit.name }}</td>
          <td>{{ test.client.name }}</td>
          <td :userId="test.userId">{{ test.userName }}</td>
          <td><TestStatus :status="test.status" /></td>
        </tr>
      </tbody>
    </table>
    <PanelEditTest />
  </div>
</template>

<script>
import { mapState } from "vuex";
import TestStatus from "@/components/TestStatus";
import LoadingSpinner from "@/components/LoadingSpinner";
import PanelEditTest from "@/components/PanelEditTest";
import StatusFilterToggle from "@/components/StatusFilterToggle";

export default {
  name: "AdminLab",
  data() {
    return {
      processing: false,
      tests: [],
      statusFilter: null
    };
  },
  props: {},
  components: {
    TestStatus,
    LoadingSpinner,
    PanelEditTest,
    StatusFilterToggle
  },
  methods: {},
  computed: {
    ...mapState("TestsStore", ["allTests"])
  },
  mounted() {
    this.$store.dispatch("TestsStore/subscribeAll", {
      status: this.statusFiler
    });
  },
  beforeDestroy() {
    this.$store.dispatch("TestsStore/unsubscribeAll");
  },
  watch: {
    statusFilter(to) {
      this.$store.dispatch("TestsStore/unsubscribeAll");
      this.$store.dispatch("TestsStore/subscribeAll", {
        statusFilter: to
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";
</style>
